import type { Endpoint } from ".";

export const getPropertyAttributes: Endpoint = {
  id: "getPropertyAttributes",
  method: "GET",
  path: "/projects/{project_id}/properties/{property_id}/attributes",
  summary: "Get site survey",
  description:
    "Returns the most recent site-survey attributes for the property. Returns null when no survey exists.",
  params: [
    {
      name: "project_id",
      in: "path",
      required: true,
      description: "UUID of the project.",
      type: "uuid",
      defaultFromClientId: true,
    },
    {
      name: "property_id",
      in: "path",
      required: true,
      description: "UUID of the property.",
      type: "uuid",
    },
  ],
};
